import { useEffect, useState } from 'react'
import { api } from '../api.js'

const MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août',
              'sept.', 'oct.', 'nov.', 'déc.']

// Ce que donne le portail, en chiffres présentables en conseil municipal.
// Volontairement rien sur les personnes : mesurer le service rendu, pas
// surveiller qui traite le plus vite.
export default function Bilan({ onOuvrir }) {
  const [mois, setMois] = useState(12)
  const [d, setD] = useState(null)

  useEffect(() => { api.bilan(mois).then(setD).catch(() => setD(null)) }, [mois])
  if (!d) return <p className="chargement">Chargement…</p>

  const pic = Math.max(1, ...d.par_mois.map((m) => m.n))

  return (
    <>
      <h1>Ce que donne votre portail</h1>
      <p className="chapo">De quoi rendre compte en conseil municipal, et repérer ce qui coince.</p>

      <div className="ligne">
        <label htmlFor="periode">Sur</label>
        <select id="periode" value={mois} onChange={(e) => setMois(Number(e.target.value))}>
          <option value={3}>les 3 derniers mois</option>
          <option value={12}>les 12 derniers mois</option>
          <option value={24}>les 2 dernières années</option>
        </select>
      </div>

      <div className="kpis">
        <div className="kpi">
          <span className="lbl">Demandes reçues</span>
          <strong>{d.recus}</strong>
          <span className="detail">déposées en ligne, sans passer au guichet</span>
        </div>
        <div className="kpi">
          <span className="lbl">Demandes traitées</span>
          <strong>{d.clos}</strong>
          <span className="detail">{d.ouverts} encore en cours</span>
        </div>
        <div className="kpi">
          <span className="lbl">Délai habituel</span>
          <strong>{d.delai_median != null ? formatJours(d.delai_median) : '—'}</strong>
          <span className="detail">du dépôt à la réponse</span>
        </div>
        <div className={`kpi ${d.dormants.length ? 'alerte' : ''}`}>
          <span className="lbl">Dossiers en attente</span>
          <strong>{d.dormants.length}</strong>
          <span className="detail">sans mouvement depuis 15 jours</span>
        </div>
      </div>

      {d.par_mois.length > 1 && (
        <section className="carte">
          <h2>Demandes reçues par mois</h2>
          <div className="histogramme">
            {d.par_mois.map((m) => {
              const [annee, numero] = m.mois.split('-')
              return (
                <div key={m.mois} title={`${m.n} demandes`}>
                  <i style={{ height: `${Math.round((m.n / pic) * 100)}%` }} />
                  <span>{MOIS[Number(numero) - 1]}</span>
                  <span className="an">{annee.slice(2)}</span>
                </div>
              )
            })}
          </div>
        </section>
      )}

      <div className="deux">
        <section className="carte">
          <h2>Par démarche</h2>
          <table className="tableau">
            <thead><tr><th>Démarche</th><th>Reçues</th><th>Délai habituel</th><th>Le plus long</th></tr></thead>
            <tbody>
              {d.par_demarche.map((l) => (
                <tr key={l.titre}>
                  <td><strong>{l.titre}</strong></td>
                  <td className="mono">{l.recus}</td>
                  <td className="mono">{l.delai_median != null ? formatJours(l.delai_median) : '—'}</td>
                  <td className="mono">{l.delai_max != null ? formatJours(l.delai_max) : '—'}</td>
                </tr>
              ))}
              {!d.par_demarche.length && (
                <tr><td colSpan={4} className="vide">Aucune demande sur la période.</td></tr>
              )}
            </tbody>
          </table>
          <p className="aide">Le délai habituel est la valeur médiane : un dossier exceptionnel
            ne fausse pas la lecture. La colonne « le plus long » est là pour le repérer.</p>
        </section>

        <aside className="carte">
          <h2>Dossiers à ne pas oublier</h2>
          {d.dormants.length ? (
            <>
              <p className="aide">Sans mouvement depuis deux semaines ou plus.</p>
              <ul className="dormants">
                {d.dormants.map((r) => (
                  <li key={r.id}>
                    <button onClick={() => onOuvrir(r.id)}>
                      <span className="mono">{r.number}</span>
                      <span className="titre">{r.titre}</span>
                      <span className="jours">{r.jours} j</span>
                    </button>
                  </li>
                ))}
              </ul>
            </>
          ) : <p className="aide">Aucun dossier oublié. Tout avance.</p>}
        </aside>
      </div>

      <p className="aide">{d.note}</p>
    </>
  )
}

function formatJours(j) {
  if (j < 1) return 'moins d\'un jour'
  if (j < 2) return '1 jour'
  if (j < 60) return `${Math.round(j)} jours`
  return `${Math.round(j / 30)} mois`
}
